import React from 'react'
import { Button } from '@mui/material'

import { ReactComponent as AiIcon } from '../../common/icons/aiPower.svg'

export default function GenerateModuleButton({ onClick }) {
  return (
    <>
      <Button variant='outlined' startIcon={<AiIcon />} onClick={onClick} sx={styles.buttonOutlined}>
        Generate with AI
      </Button>
    </>
  )
}

const styles = {
  buttonOutlined: {
    padding: '0px 30px',
    borderRadius: '14px',
    fontFamily: 'Plus Jakarta Sans',
    fontSize: '16px',
    height: '40px',
    color: '#6123FF',
    borderColor: '#6123FF',
    textTransform: 'none'
  }
}
